import { Route, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

const PrivateRoute = ({ component: Component, isLoggedIn, ...rest }) => (
    <Route
        render={(props) => {

            if (isLoggedIn) {
                return <Component {...props} />
            } else {
                return <Redirect to={`/login`} />

            }
        }}
        {...rest}
    />
)

PrivateRoute.propTypes = {
    auth: PropTypes.object.isRequired,
}

const mapStateToProps = (state) => ({
    isLoggedIn: state.Auth.isLoggedIn,
})

export default connect(mapStateToProps)(PrivateRoute)
